document.addEventListener('click', (event) => {
  const openButton = event.target.closest('[data-menu-open]');
  if (openButton) {
    const dialog = document.querySelector('[data-menu-drawer]');
    if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    return;
  }
  const closeButton = event.target.closest('[data-menu-close]');
  if (closeButton) {
    const dialog = closeButton.closest('[data-menu-drawer]');
    if (dialog && typeof dialog.close === 'function') dialog.close();
    return;
  }
  const thumbnail = event.target.closest('[data-thumb]');
  if (thumbnail) {
    const gallery = thumbnail.closest('.product-gallery');
    const main = gallery ? gallery.querySelector('[data-main-image]') : document.querySelector('[data-main-image]');
    if (main) main.src = thumbnail.dataset.thumb;
    const parent = thumbnail.closest('.thumbs');
    if (parent) parent.querySelectorAll('.thumb-button').forEach((button) => button.classList.toggle('is-active', button === thumbnail));
    return;
  }
  const quantityButton = event.target.closest('[data-qty]');
  if (quantityButton) {
    const form = quantityButton.closest('form') || document;
    const input = form.querySelector(quantityButton.dataset.qty) || document.querySelector(quantityButton.dataset.qty);
    if (!input) return;
    const current = Number.parseInt(input.value || '1', 10);
    const next = current + (quantityButton.dataset.delta === 'minus' ? -1 : 1);
    input.value = String(Math.max(1, Number.isFinite(next) ? next : 1));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

document.addEventListener('click', (event) => {
  const dialog = event.target.closest('[data-menu-drawer]');
  if (dialog && event.target === dialog && typeof dialog.close === 'function') dialog.close();
});

document.addEventListener('change', (event) => {
  const selector = event.target.closest('[data-variant-select]');
  if (!selector) return;
  const option = selector.options[selector.selectedIndex];
  const form = selector.closest('form');
  const price = form?.parentElement?.querySelector('[data-product-price]') || document.querySelector('[data-product-price]');
  const compare = form?.parentElement?.querySelector('[data-compare-price]') || document.querySelector('[data-compare-price]');
  if (price && option?.dataset.price) price.textContent = option.dataset.price;
  if (compare) {
    const comparePrice = option?.dataset.comparePrice || '';
    compare.textContent = comparePrice;
    compare.hidden = !comparePrice;
  }
});
